import { render, staticRenderFns } from "./CampaignTeacher.vue?vue&type=template&id=095f20a0&"
import script from "./CampaignTeacher.vue?vue&type=script&lang=js&"
export * from "./CampaignTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports